module.exports = __webpack_public_path__ + "media/upload-2020-teaser.d6b84a4c.mp4";